<template>
  <div class="content_block_container">
    <b-row class="content_block_topbar">
      <b-col><h5 class="title_content_block">Iframe</h5></b-col>
      <b-col style="text-align: right">
        <b-button
          class="controller_button_content"
          @click="$emit('shiftUpBlock', index)"
          ><b-icon icon="caret-up-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('shiftDownBlock', index)"
          ><b-icon icon="caret-down-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('deleteBlock', index)"
          ><b-icon icon="trash-fill" aria-hidden="true"></b-icon
        ></b-button>
      </b-col>
    </b-row>
    <b-container class="form_button_content">
      <b-row>
        <b-col sm="3">
          <p>Code Iframe:</p>
        </b-col>
        <b-col sm="6">
          <b-form-input
            v-model="iframe_property.code"
            placeholder="Code de l'iframe"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["iframe_property", "index"],
  data() {
    return {
    };
  },
};
</script>

<style scoped>
</style>